import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getCall, putCall } from "../../utils/api";
import toast from "react-hot-toast";

const initialState = {
    versionData: null,
    loading: false,
    updating: false,
    error: null,
    success: null,
    status: "idle",
};

// Get version details
export const getVersionDetails = createAsyncThunk(
    "versionControl/getVersionDetails",
    async (_, { rejectWithValue }) => {
        try {
            const response = await getCall("/admin/v1/version-control", false);
            return response.data;
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.message || "Failed to fetch version details"
            );
        }
    }
);

// Update version details
export const updateVersionDetails = createAsyncThunk(
    "versionControl/updateVersionDetails",
    async (versionData, { rejectWithValue }) => {
        try {
            const response = await putCall("/admin/v1/version-control", versionData, false);
            toast.success("Version details updated successfully!");
            return response.data;
        } catch (error) {
            toast.error(error.response?.data?.message || "Failed to update version details");
            return rejectWithValue(
                error.response?.data?.message || "Failed to update version details"
            );
        }
    }
);

const versionControlSlice = createSlice({
    name: "versionControl",
    initialState,
    extraReducers: (builder) => {
        builder
            // Get version details
            .addCase(getVersionDetails.pending, (state) => {
                state.loading = true;
                state.error = null;
                state.status = "loading";
            })
            .addCase(getVersionDetails.fulfilled, (state, action) => {
                state.loading = false;
                state.versionData = action.payload;
                state.status = "succeeded";
            })
            .addCase(getVersionDetails.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
                state.status = "failed";
            })
            // Update version details
            .addCase(updateVersionDetails.pending, (state) => {
                state.updating = true;
                state.error = null;
            })
            .addCase(updateVersionDetails.fulfilled, (state, action) => {
                state.updating = false;
                state.versionData = action.payload;
                state.success = "Version details updated successfully";
            })
            .addCase(updateVersionDetails.rejected, (state, action) => {
                state.updating = false;
                state.error = action.payload;
            });
    },
});

export default versionControlSlice.reducer;